module.exports = __webpack_public_path__ + "static/media/strasad@2x.6bc9fe56.png";